module.exports = __webpack_public_path__ + "img/btn_slide_prev.bd904675.svg";